import _ from "lodash";
import {
  DestinationStandardMapping,
  DestinationStandardMappingItemProperty,
} from "../types";

const conversionTrackingPinterestProperties: DestinationStandardMappingItemProperty[] = [
  {
    key: "value",
    exampleValue: 100,
    type: "number",
    additionalTransformation: {
      operation: "castPropertyValue",
      operandValue: "number",
    },
  },
  {
    key: "order_quantity",
    exampleValue: 1,
    type: "number",
    additionalTransformation: {
      operation: "castPropertyValue",
      operandValue: "number",
    },
  },
];

const audienceCreationPinterestProperties: DestinationStandardMappingItemProperty[] = _.concat(
  conversionTrackingPinterestProperties,
  [
    {
      key: "currency",
      exampleValue: "USD",
      type: "string",
      allowedValues: ["USD", "GBP", "CAD", "EUR", "AUD", "NZD"],
      additionalTransformation: {
        operation: "uppercasePropertyValue",
      },
    },
    {
      key: "order_id",
      exampleValue: "X-15148",
      type: "string",
    },
    // TODO: Line items?
    {
      key: "promo_code",
      exampleValue: "WINTER10",
      type: "string",
    },
    {
      key: "property",
      exampleValue: "Athleta",
      type: "string",
    },
    {
      key: "search_query",
      exampleValue: "boots",
      type: "string",
    },
    {
      key: "video_title",
      exampleValue: "How to style your Parker Boots",
      type: "string",
    },
    {
      key: "lead_type",
      exampleValue: "Newsletter",
      type: "string",
    },
  ]
);

export const pinterestStandardMapping: DestinationStandardMapping = {
  wildcard: {
    description:
      "Add any additional event that you’ve defined for the purpose of audience targeting." +
      "Unique events aren’t available for conversion reporting. Keep in mind that whitespace will be trimmed" +
      " from raw event names passed through the tag.",
    propertiesArr: audienceCreationPinterestProperties,
  },
  items: [
    {
      eventName: "Checkout",
      description: "Track people who complete transactions",
      propertiesArr: audienceCreationPinterestProperties,
    },
    {
      eventName: "AddToCart",
      description: "Track people who add items to shopping carts",
      propertiesArr: audienceCreationPinterestProperties,
    },
    {
      eventName: "PageVisit",
      description:
        "Track people who view primary pages, such as product pages and article pages",
      propertiesArr: audienceCreationPinterestProperties,
    },
    {
      eventName: "Signup",
      description: "Track people who sign up for your product or service",
      propertiesArr: audienceCreationPinterestProperties,
    },
    {
      eventName: "WatchVideo",
      description: "Track people who watch videos",
      propertiesArr: audienceCreationPinterestProperties,
    },
    {
      eventName: "Lead",
      description: "Track people who show interest in your product or service",
      propertiesArr: audienceCreationPinterestProperties,
    },
    {
      eventName: "Search",
      description:
        "Track people who perform searches on your website to look for specific products or store locations",
      propertiesArr: audienceCreationPinterestProperties,
    },
    {
      eventName: "ViewCategory",
      description: "Track people who view category pages",
      propertiesArr: audienceCreationPinterestProperties,
    },
    {
      eventName: "Custom",
      description:
        "Track a custom event. Use this event name to track a special event that you want to" +
        " include in your conversion reporting",
      propertiesArr: audienceCreationPinterestProperties,
    },
  ],
};

export const getPinterestStandardMapping = async () => {
  return pinterestStandardMapping;
};
